import gql from 'graphql-tag';

export default gql`
  query fulfillmentNote($id: ID!) {
    fulfillmentNote(id: $id) {
      fulfillmentNoteId
      fulfillmentNoteShortCode
      deliveryStartDateTime
      deliveryEndDateTime
      paymentMethod
      total
      totalItemPrice
      discount
      itemCount
      orderIds
      fulfillmentNoteStatus
      totalVat
      totalVatOnProducts
      orderDateTime
      subTotalBeforeVat
      firstOrder {
        status
      }
      feedback {
        id
        objectType
        objectId
        submittedByUserId
        rating
        tags
        comment
        dismissedAt
        submittedAt
        createdAt
        updatedAt
      }
      items {
        total
        totalBeforeVat
        unitPriceAfterDiscount
        amountAfterDiscount
        deliveredNote
        buyerNote
        unitPrice {
          value
          vat
          vatIncluded
        }
        deliveryQuantity
        orderedQuantity
        product {
          id
          name
          note
          price
          vat
          uomLocal
          uom
          inStock
          supplierInternalCode
          imageUrl
          baseUnit
          baseUom
          netUnit
          netUom
          priceV2 {
            vat
          }
        }
      }
      deliveryFee {
        fee
        discount
        active
      }
      invoiceNote
    }
  }
`;
